import { useFetch } from "lib/useFetch";
import { useProdCopyUrl } from "components/PreferencesDialog/redesignUtils";

const jsApiUrl = (prodCopyUrl) => `/research/${prodCopyUrl}/subscription/facets/validate`;

export default function useFetchFacetValidate(requestBody, condition = true) {
  const prodCopyUrl = useProdCopyUrl();
  const response = useFetch(jsApiUrl(prodCopyUrl), JSON.stringify(requestBody), "POST", condition);

  return response;
}
